const SelectLoader =({label})=>{
    return (
        <div className="search-c__menu">
        <div className="search-c__menu-cont">
          <div className="search-c__option disable">
            {label}
          </div>
        </div>
      </div>
    )
}
export default SelectLoader;